import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils/storage";

import Paths from "./paths";
import * as Types from "./types";

export const titleListService = (params: Types.TitleListRequest) =>
  RestAPIClient.call<Types.TitleListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const titleListShortService = (params: Types.TitleListRequest) =>
  RestAPIClient.call<Types.TitleListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const titleCreateService = (params: Types.TitleCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const titleDetailService = (id: number) =>
  RestAPIClient.call<Types.Title>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const titleUpdateService = (params: Types.TitleUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
